module.exports = __webpack_public_path__ + "../resources/images/illustration_search_folder-7deaa53c12325fccb602654eb64f75f9.svg";